import { ResponseStatus } from "../models/api/apiModels";
export const INTERNAL_SERVER_ERROR_MSG = 'An unexpected error occurred. Please try again later.';
export const EXPIRED_SESSION_ERROR_MSG = 'User session expired.';
export const isFetchBaseQueryError = (error) => {
    return typeof error === 'object' && error != null && 'status' in error;
};
export const isErrorWithMessage = (error) => {
    return (typeof error === 'object' &&
        error != null &&
        'message' in error &&
        typeof error.message === 'string');
};
export const transformApiResponse = (response) => {
    if (response.responseStatus === ResponseStatus.FAILURE) {
        throw response.responseError;
    }
    return response.data;
};
export const handleApiErrorResponse = (errMsg) => {
    throw new Error(errMsg);
};
export const getApiErrorMsg = (error) => {
    let msg = null;
    if (isFetchBaseQueryError(error)) {
        msg = 'error' in error ? error.error : JSON.stringify(error.data);
    }
    else if (isErrorWithMessage(error)) {
        msg = error.message;
    }
    return msg;
};
export const getResponseError = (response) => {
    var _a;
    return (_a = response.data) === null || _a === void 0 ? void 0 : _a.responseError;
};
export const addCsrfTokenToRequestHeader = (headers, type) => {
    if (type === 'mutation') {
        const matches = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
        const token = matches ? matches[1] : null;
        if (token)
            headers.set('X-XSRF-TOKEN', token);
    }
    return headers;
};
